import type { I18nContextValue } from "../../../app/i18n/useI18n";
import type { PaymentRow } from "./personDetailTypes";

/** Expand only the server's explicit allocations; never infer receipts from dates. */
export function paymentAllocations(payment: PaymentRow): PaymentRow[] {
  return payment.allocations?.length ? payment.allocations : [payment];
}

export function personPaymentDescription(payment: PaymentRow, text: I18nContextValue["text"]): string {
  if ((payment.allocations?.length ?? 0) > 1) {
    return text("Payment allocation count").replace("{0}", String(payment.allocations!.length));
  }
  return payment.openItemDescription || payment.contractName || "";
}
